module.exports = __webpack_public_path__ + "media/images/Download_on_the_App_Store_blk-8c4986ee4828b47d16f5cd694ef065f2.svg";